import axios from 'axios'
import { axiosConfig } from '@/config/axiosConfig.js'
import { _get_common_click_event_options } from '@/utils/emap/emap_common.js'

const GEOMAP_DESCRIPTION_MAP = {
    'id_157': 'Reservoir9daysRainfall.png',
    'id_360': 'Reservoir4weekRainfall.png',
}

export async function set_product_geomap_images_click_event(marker, options) {
    const { product, img_id, client_name, click_callback } = options
    const { id, external } = product
    const res = await axios.get(`${client_name}/${external}/${img_id}`, axiosConfig)
    try {
        if (!(res.data instanceof Object)) {
            res.data = JSON.parse(res.data);
        }
        if(res.data['status'] === 'success' && res.data['path'] && res.data['path'].length > 0) {
            let html = res.data['path'].reduce((accumlator_html, image_url) => {
                return `${accumlator_html}<img src="${image_url}" width="100%">`
            }, '')
    
            if (GEOMAP_DESCRIPTION_MAP[id]) {
                html = `${html}
                    <a href="/static/images/product/atlas_description/${GEOMAP_DESCRIPTION_MAP[id]}" 
                        target="_blank" 
                        style="text-decoration:none;"
                    >
                        <div class="popup_description_link">說明</div>
                    </a>
                `
            }
    
            marker.on('click', () => {
                click_callback({
                    ..._get_common_click_event_options(options),
                    html, 
                    raw_html: true
                })
            })
        }
    } catch (err) {
        console.error(err)
    }
}
